// import { resolve } from 'core-js/fn/promise'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '',
        component: resolve => require(['../views/home.vue'], resolve),
        hidden: false,
        children: [
            {
                path: '',
                name: '首页',
                component: resolve => require(['../views/index/index.vue'], resolve),
                meta: { title: '百昌科技' },
                hidden: false,
                alias: 'index'
            },
            {
                path: '/join',
                name: '走进百昌',
                component: resolve => require(['../views/join/join.vue'], resolve),
                meta: { title: '走进百昌-百昌科技' },
                hidden: false,
            },
            {
                path: '/product',
                name: '产品中心',
                component: resolve => require(['../views/product/product.vue'], resolve),
                meta: { title: '产品中心-百昌科技' },
                hidden: false,
                children: [
                    {
                        path: '/product',
                        redirect: 'productCenter'
                    },
                    {
                        path:'productCenter',
                        name:'productCenter',
                        component: resolve => require(['../views/product/productCenter.vue'], resolve),
                        meta:{title:'产品中心-百昌科技'},
                        hidden: false
                    },
                    {
                        path: 'digitalBC',
                        name: 'digitalBC',
                        component: resolve => require(['../views/product/digitalBC.vue'], resolve),
                        meta:{title:'数字百昌'},
                        hidden: false,
                        redirect:"/product/digitalBC/introduce",
                        children:[
                            {
                                path:"introduce",
                                name:"introduce",
                                component: resolve => require(['../views/product/introduce.vue'], resolve),
                                meta:{title:'数字百昌-介绍页'},
                                hidden: false,
                            },
                            {
                                path:"caseShow",
                                name:"caseShow",
                                component: resolve => require(['../views/product/case-show.vue'], resolve),
                                meta:{title:'数字百昌-案例展示'},
                                hidden: false,
                            },
                            {
                                path:"caseDetail",
                                name:"caseDetail",
                                component: resolve => require(['../views/product/case-detail.vue'], resolve),
                                meta:{title:'数字百昌-案例详情'},
                                hidden: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '/cooperate',
                name: '业务合作',
                component: resolve => require(['../views/cooperate/cooperate.vue'], resolve),
                meta: { title: '业务中心-百昌科技' },
                hidden: false,
            },
            {
                path: '/news',
                name: '新闻中心',
                component: resolve => require(['../views/news/news.vue'], resolve),
                meta: { title: '新闻中心' },
                hidden: false,
                children: [
                    {
                        path: '/news',
                        redirect: 'newsCenter'
                    },
                    {
                        path: 'newsCenter',
                        name: 'newsCenter',
                        component: resolve => require(['../views/news/components/newsCenter.vue'], resolve),
                        meta:{title:'新闻中心'},
                        hidden: false
                    },
                    {
                        path: 'newsListPages',
                        name: 'newsListPages',
                        component: resolve => require(['../views/news/components/newsListPages.vue'], resolve),
                        meta: { title: '新闻列表' },
                        hidden: false,
                    },
                    {
                        path: 'newsDetails',
                        name: 'newsDetails',
                        component: resolve => require(['../views/news/components/newsDetails.vue'], resolve),
                        meta:{title:'新闻详情'},
                        hidden: false
                    }
                ]
            },
            {
                path: '/about',
                name: '关于我们',
                component: resolve => require(['../views/about/about.vue'], resolve),
                meta: { title: '关于我们-百昌科技' },
                hidden: false,
            },
            {
                path: '*',
                name: '404',
                component: resolve => require(['../views/404/404.vue'], resolve),
                meta: { title: '404' },
                hidden: true,
            }
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.query.anchor) {//路由跳转要传需要定的锚点的id 例如；this.$router.push("index?anchor=download")
            return {
                selector: "#" + to.query.anchor
            }
        } else {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    },
    routes
})

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
